import { useDataQuery } from "@Libs/DataLayer/hooks/useDataQuery";
import {
  getServiceRequestCategory,
  IServiceRequestCategory,
} from "../services/serviceRequests";

export const useServiceRequestCategory = (
  serviceRequestId: number | undefined
) => {
  const { data, isLoading } = useDataQuery<IServiceRequestCategory>(
    ["serviceRequest", serviceRequestId],
    () => getServiceRequestCategory(serviceRequestId as number),
    { enabled: !!serviceRequestId }
  );

  return {
    categoryId: data?.categoryId,
    isLoading,
  };
};
